export default "__VITE_ASSET__B9N8RLTV__"